// 角头 node 类型
export enum CornerNodeType {
  Row = 'row',
  Col = 'col',
  Series = 'series',
}
